import React, { useState, useEffect } from 'react';

const iconContext = require.context('../assets/icons', true, /\.svg$/);

// Build map of all packs and their icons
const allPacks = {};
iconContext.keys().forEach((path) => {
  const packMatch = path.match(/^\.\/([^/]+)\/(.+)\.svg$/);
  if (packMatch) {
    const [, packName, iconName] = packMatch;
    if (!allPacks[packName]) allPacks[packName] = {};
    allPacks[packName][iconName] = iconContext(path);
  }
});

export function TimelineIcon({ name, pack = 'default' }) {
  const [svgContent, setSvgContent] = useState(null);
  const iconSrc = (pack === 'custom' || pack === 'uploaded') ? name : allPacks[pack]?.[name];
  
  const isSvg = iconSrc && iconSrc.toLowerCase().endsWith('.svg');

  useEffect(() => {
    if (!iconSrc || !isSvg) return;
    
    fetch(iconSrc)
      .then(res => res.text())
      .then(text => setSvgContent(text));
  }, [iconSrc, isSvg]);
  
  if (!iconSrc) {
    return <div className="timeline-icon">?</div>;
  }

  if (!isSvg) {
    return (
      <div className="timeline-icon timeline-icon-raster">
        <img 
          src={iconSrc} 
          alt="icon" 
          style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} 
        />
      </div>
    );
  }
  
  return (
    <div className="timeline-icon" dangerouslySetInnerHTML={{ __html: svgContent }} />
  );
}

export const getAvailableIcons = (pack) => Object.keys(allPacks[pack] || {});
export const getAvailablePacks = () => Object.keys(allPacks);

export default TimelineIcon;
